<script setup>
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useCompareStore } from '../stores/compareStore'

const { t } = useI18n()
const router = useRouter()
const compareStore = useCompareStore()

const handleCompare = () => {
  if (compareStore.canCompare) {
    router.push({ name: 'FestivalCompare' })
  }
}

const handleKeydown = (event) => {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault()
    handleCompare()
  }
}
</script>

<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition-transform duration-300 ease-out"
      enter-from-class="translate-y-full"
      enter-to-class="translate-y-0"
      leave-active-class="transition-transform duration-200 ease-in"
      leave-from-class="translate-y-0"
      leave-to-class="translate-y-full"
    >
      <div
        v-if="compareStore.hasSelection"
        class="fixed bottom-0 left-0 right-0 z-50 bg-brand-surface/95 backdrop-blur-sm border-t border-brand-muted/20 shadow-lg"
        role="region"
        aria-label="Compare selection bar"
      >
        <div class="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
          <!-- Selection count -->
          <div class="flex items-center gap-2">
            <span class="inline-flex items-center justify-center w-8 h-8 rounded-full bg-brand-accent/20 text-brand-accent font-bold text-sm">
              {{ compareStore.count }}
            </span>
            <span class="text-brand-text text-sm hidden sm:inline">
              {{ t('compare.selected', { count: compareStore.count }) }}
            </span>
            <span class="text-brand-muted text-xs sm:hidden">
              {{ t('compare.selected', { count: compareStore.count }) }}
            </span>
          </div>

          <!-- Actions -->
          <div class="flex items-center gap-2">
            <button
              type="button"
              class="px-3 py-1.5 text-sm text-brand-muted hover:text-brand-text transition-colors"
              @click="compareStore.clear"
            >
              {{ t('compare.clear') }}
            </button>
            <button
              type="button"
              :disabled="!compareStore.canCompare"
              :class="[
                'px-4 py-1.5 rounded-lg text-sm font-medium transition-all',
                compareStore.canCompare
                  ? 'bg-brand-accent text-white hover:bg-brand-accent/90'
                  : 'bg-brand-muted/30 text-brand-muted cursor-not-allowed'
              ]"
              :aria-label="t('compare.compare_now', { count: compareStore.count })"
              @click="handleCompare"
              @keydown="handleKeydown"
            >
              {{ t('compare.compare_now', { count: compareStore.count }) }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>